import { render, staticRenderFns } from "./OrderSingleSummarySubtotals.vue?vue&type=template&id=fbd9550c&"
import script from "./OrderSingleSummarySubtotals.vue?vue&type=script&lang=js&"
export * from "./OrderSingleSummarySubtotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports